<button #snackbarDs class="snackbarDs__cont snackbarDs__cont--{{size}}" aria-label="snackbarDs" [class.clickable]="!action">
  <div class="snackbarDs__body">
    <ng-container *ngIf="snackbarIcon">
      <app-ds-icon
        class="snackbarDs__icon"
        [icon]="snackbarIcon"
        [size]="24"
        [color]="iconFillColor">
      </app-ds-icon>
    </ng-container>
    <ng-container *ngIf="message">
      <app-ds-typography
        class="snackbarDs__message"
        [text]="message"
        [size]="fontSize"
        [color]="fontColor"
        [fontFamily]="fontFamily">
      </app-ds-typography>
    </ng-container>
  </div>
  @if (action) {
    <button class="snackbarDs__action" aria-label="snackbarDs--action">
      <app-ds-typography
        [text]="action"
        [size]="fontSize"
        [color]="fontColor"
        [fontFamily]="fontFamily"
        (click)="clickedSnackbar(true)">
      </app-ds-typography>
    </button>
  }
</button>